(function () {
    var toc = document.querySelector('[data-article-toc]');
    var content = document.querySelector('.article-content');

    if (!toc || !content) {
        return;
    }

    var headings = Array.prototype.slice.call(content.querySelectorAll('h1, h2'));

    if (headings.length < 2) {
        toc.remove();
        return;
    }

    var usedIds = {};

    function anchorFor(heading) {
        if (heading.id) {
            return heading.id;
        }

        var base = (heading.textContent || 'section')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '') || 'section';

        usedIds[base] = (usedIds[base] || 0) + 1;
        heading.id = usedIds[base] > 1 ? base + '-' + usedIds[base] : base;

        return heading.id;
    }

    var entries = headings.map(function (heading) {
        var label = heading.textContent.trim();

        var item = document.createElement('a');
        item.className = 'dot-nav__item';
        item.href = '#' + anchorFor(heading);
        item.setAttribute('aria-label', label);

        var labelEl = document.createElement('span');
        labelEl.className = 'dot-nav__label';
        labelEl.textContent = label;

        var dot = document.createElement('span');
        dot.className = 'dot-nav__dot';
        dot.setAttribute('aria-hidden', 'true');

        item.appendChild(labelEl);
        item.appendChild(dot);
        toc.appendChild(item);

        return {heading: heading, item: item};
    });

    toc.hidden = false;

    function syncActive() {
        var current = entries[0];

        entries.forEach(function (entry) {
            if (entry.heading.getBoundingClientRect().top <= 140) {
                current = entry;
            }
        });

        entries.forEach(function (entry) {
            entry.item.classList.toggle('is-active', entry === current);
        });
    }

    syncActive();
    window.addEventListener('scroll', syncActive, {passive: true});
    window.addEventListener('resize', syncActive, {passive: true});
})();
